export const SET_SIDEBAR = "SET_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";
